function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { actions as cmsActions } from '../../reducers/cms.reducer';
import SiteSettingsData from './SiteSettings.context';
import PageBackButton from '../common/page/PageBackButton.react';
import SEO from '../common/page-components/SEO.react';
var SiteSettingsPage = function SiteSettingsPage() {
  var _useParams = useParams(),
    app = _useParams.app;
  var dispatch = useDispatch();
  var siteSettings = useSelector(function (s) {
    return s.cms.siteSettings;
  });
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  useEffect(function () {
    dispatch({
      type: cmsActions.siteSettings,
      payload: {
        formData: {
          clientAppID: app
        }
      }
    });
  }, [app]);
  useEffect(function () {
    setState(siteSettings[app] || {});
  }, [siteSettings, app]);
  return /*#__PURE__*/React.createElement(SiteSettingsData.Provider, {
    value: [state, setState]
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, /*#__PURE__*/React.createElement(PageBackButton, null), /*#__PURE__*/React.createElement(SEO, {
    type: "siteSettings",
    itemID: app,
    metadata: (state === null || state === void 0 ? void 0 : state.metadata) || {},
    header: "Default SEO Data",
    permission: "edit-".concat(app, "-settings")
  })));
};
export default SiteSettingsPage;